import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PieComponent from '../components/PieComponent';
import * as c from '../constants';
import * as actions from '../actions';
import CollectionsGraph2 from './CollectionsGraph2';

import CmsContext from '../../../context/CmsContext'

const EGovernmentDashboard = ({ getCounts, counts }) => {
  const cmsContext = useContext(CmsContext);
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES');

  const { transactions } = counts;
  
  const LasPinasTransactions = {
    EBPLS: transactions?.EBPLS || 0,
    RPTAX: transactions?.RPTAX || 0,
  }

  useEffect(() => {
    getCounts();
  }, []);

  const formatData = (data) => {
    if (!data) return [];
    return Object.keys(data).map((val) => {
      return { name: val, value: data[val] };
    });
  };

  const cmsFilteredEgovData = () => {
    const data = c.E_GOV_COLORS ||  []

    if (_.get(CMS_VARIABLES, 'LGU_NAME') === "Las Piñas"){
      return c.LAS_PINAS_E_GOV_COLORS || []
    }
    return data?.filter(item => [
      _.get(CMS_COMPONENTS, "BPLS_SERVICES_SUB_MENU") && "Business Process Licensing (BPLS)",
      _.get(CMS_COMPONENTS, "BTAX_SERVICES_SUB_MENU") && "Business Tax (BTAX)",
      _.get(CMS_COMPONENTS, "CEDULA_SERVICES_SUB_MENU") && "Cedula (CDL)",
      _.get(CMS_COMPONENTS, "CIVIL_REGISTRY_SERVICES_SUB_MENU") && "Birth Certificates (PSA)",
      _.get(CMS_COMPONENTS, "OCCUPATIONAL_PERMIT_SERVICES_SUB_MENU") && "Occupational and Health (OHP)",
      _.get(CMS_COMPONENTS, "RPT_SERVICES_SUB_MENU") && "Real Property Tax (RPTAX)",
    ].indexOf(item.name) === -1)
  }

  const renderLegends = (dt) =>
    dt.map((x) => (
      <div key={x.name} className="legend-item">
        <div
          style={{
            background: `${x.color}`,
            width: 20,
            height: 20,
            marginRight: 20,
          }}
        />
        <div className="legend-text">{x.name}</div>
      </div>
    ));

  return (
    <div className="container-fluid mb-3">
      <div className="row">
        <div className="col pl-0 mb-3">

          <div className="row pie">
            <div className="col-12 pie-title text-left">Transactions</div>
            <div className="col-12 pie-wrapper ">

              <PieComponent chartData={formatData(_.get(CMS_VARIABLES, 'LGU_NAME') === "Las Piñas" ? LasPinasTransactions : transactions )} />

            </div>
            <div className="legends-wrapper-v2 px-3">{renderLegends(cmsFilteredEgovData())}</div>
          </div>

        </div>
        <div className="col-sm-12 col-xl-8 pl-0">
          <CollectionsGraph2 className="m-0" />
        </div>
      </div>
    </div>
  )
}


EGovernmentDashboard.defaultProps = {
  counts: {},
};

EGovernmentDashboard.propTypes = {
  getCounts: PropTypes.instanceOf(Function).isRequired,
  counts: PropTypes.instanceOf(Object),
};

const mapStateToProps = ({ api }) => ({
  counts: _.get(api, `${c.GET_COUNTS}.res`),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(EGovernmentDashboard);
